import { NavLink } from "react-router-dom";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@/components/ui/tooltip";

export function HeaderNavLink({
	to,
	label,
	icon: Icon,
	end,
	iconOnly,
}: {
	to: string;
	label: string;
	icon: LucideIcon;
	end?: boolean;
	iconOnly?: boolean;
}) {
	const link = (
		<NavLink
			to={to}
			end={end}
			aria-label={iconOnly ? label : undefined}
			className={({ isActive }) =>
				cn(
					"flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md group hover:scale-105 duration-300 transition-all",
					isActive
						? "text-primary font-medium"
						: "text-muted-foreground hover:text-foreground hover:bg-muted-subtle",
				)
			}
		>
			<Icon className="h-4 w-4 shrink-0 group-hover:text-primary duration-300" />
			{!iconOnly && label}
		</NavLink>
	);

	if (!iconOnly) return link;

	return (
		<Tooltip>
			<TooltipTrigger asChild>{link}</TooltipTrigger>
			<TooltipContent>{label}</TooltipContent>
		</Tooltip>
	);
}
